














import Vue from 'vue';
import { get } from 'lodash';
import gql from 'graphql-tag';
import { objectStatusColor } from '@/utils';

const WITH_VALUE = 'WITH_VALUE';
const WITH_TITLE = 'WITH_TITLE';
const WITH_TITLE_LIST = 'WITH_TITLE_LIST';

const TYPE_MAP = {
  StringAttribute: WITH_VALUE,
  DateTimeAttribute: WITH_VALUE,
  PersonAttribute: WITH_TITLE,
  GroupAttribute: WITH_TITLE,
  BooleanAttribute: WITH_VALUE,
  PeopleAttribute: WITH_TITLE_LIST,
  SurveyResponsesAttribute: WITH_TITLE_LIST,
  DateAttribute: WITH_VALUE,
  IntegerAttribute: WITH_VALUE,
  FloatAttribute: WITH_VALUE,
  AuditsAttribute: WITH_TITLE_LIST,
  ProgramAttribute: WITH_TITLE,
  OwnersGroupAttribute: WITH_TITLE_LIST,
  AssesmentsAttribute: WITH_TITLE_LIST,
  FetchersAttribute: WITH_TITLE_LIST,
  AuditAttribute: WITH_TITLE,
  ControlsAttribute: WITH_TITLE_LIST,
  ProgramsAttribute: WITH_TITLE_LIST,
  ReviewersAttribute: WITH_TITLE_LIST,
  RiskAttribute: WITH_TITLE,
  RiskFactorAttribute: WITH_TITLE,
  RiskVectorScoreAttribute: WITH_TITLE,
  RiskThresholdsAttribute: WITH_TITLE_LIST,
  ControlAttribute: WITH_TITLE,
  WorkflowGroupAttribute: WITH_TITLE,
  ObjectInRevisionAttribute: WITH_TITLE,
  VendorAttribute: WITH_TITLE,
  OrgGroupsAttribute: WITH_TITLE_LIST,
  FetcherAttribute: WITH_TITLE,
  DeviationAttribute: WITH_TITLE,
  SurveyResponseAttribute: WITH_TITLE,
  ObjectivesAttribute: WITH_TITLE_LIST,
  DocumentAttribute: WITH_TITLE,
  SurveyFullAnswerAttribute: WITH_TITLE,
  RevisionsAttribute: WITH_TITLE_LIST,
  ProcessAttribute: WITH_TITLE,
  SectionAttribute: WITH_TITLE,
  VulnerabilityAttribute: WITH_TITLE,
  IssuesAttribute: WITH_TITLE_LIST,
  SurveyFullAnswersAttribute: WITH_TITLE,
  TagInfosAttribute: WITH_TITLE_LIST,
  RequestsAttribute: WITH_TITLE_LIST,
  ExternalAttachmentAttribute: WITH_TITLE,
  AssessmentAttribute: WITH_TITLE,
  RisksAttribute: WITH_TITLE,
  CommentsAttribute: WITH_TITLE_LIST,
  ClauseAttribute: WITH_TITLE,
  SystemsAttribute: WITH_TITLE_LIST,
  DeviationsAttribute: WITH_TITLE_LIST,
  ExternalCommentAttribute: WITH_TITLE,
  ProjectsAttribute: WITH_TITLE_LIST,
  DataAssetAttribute: WITH_TITLE,
  ObjectTemplateAttribute: WITH_TITLE,
  ThreatAttribute: WITH_TITLE,
  GroupsAttribute: WITH_TITLE_LIST,
  SectionsAttribute: WITH_TITLE_LIST,
  VulnerabilitiesAttribute: WITH_TITLE_LIST,
  MarketAttribute: WITH_TITLE,
  PoliciesAttribute: WITH_TITLE_LIST,
  ProductsAttribute: WITH_TITLE_LIST,
  RiskVectorScoresAttribute: WITH_TITLE_LIST,
  ContractAttribute: WITH_TITLE,
  IncidentAttribute: WITH_TITLE,
  ClausesAttribute: WITH_TITLE_LIST,
  ProductAttribute: WITH_TITLE,
  DataAssetsAttribute: WITH_TITLE_LIST,
  FacilityAttribute: WITH_TITLE,
  ObjectTemplatesAttribute: WITH_TITLE_LIST,
  ProcessesAttribute: WITH_TITLE_LIST,
  StandardAttribute: WITH_TITLE,
  DashboardsAttribute: WITH_TITLE_LIST,
  MarketsAttribute: WITH_TITLE_LIST,
  RevisionAttribute: WITH_TITLE,
  RiskFactorsAttribute: WITH_TITLE_LIST,
  TaskAttribute: WITH_TITLE,
  RiskVectorScoreValueAttribute: WITH_TITLE,
  PolicyAttribute: WITH_TITLE,
  IncidentsAttribute: WITH_TITLE_LIST,
  ContractsAttribute: WITH_TITLE_LIST,
  CommentAttribute: WITH_TITLE,
  RequestAttribute: WITH_TITLE,
  ThreatsAttribute: WITH_TITLE_LIST,
  OrgGroupAttribute: WITH_TITLE,
  FacilitiesAttribute: WITH_TITLE_LIST,
  SystemAttribute: WITH_TITLE,
  ExternalRequestsAttribute: WITH_TITLE_LIST,
  ProjectAttribute: WITH_TITLE,
  TasksAttribute: WITH_TITLE_LIST,
  RiskThresholdAttribute: WITH_TITLE,
  StandardsAttribute: WITH_TITLE_LIST,
  WorkflowGroupsAttribute: WITH_TITLE_LIST,
  ObjectiveAttribute: WITH_TITLE,
  VendorsAttribute: WITH_TITLE_LIST,
  IssueAttribute: WITH_TITLE,
};

// The server doesn't provide the right API for this
// TODO: Implement these types as generic attribute types
const QUERY_MAP = {
  [WITH_VALUE]: {
    getQuery: type => gql`
      query DrilldownCellAttributeWithValue($id: ID!, $names: [String]!) {
        node(id: $id) {
          attrs(names: $names) {
            ... on ${type} {
              value
            }
          }
        }
      }
    `,
    update: result => {
      return get(result, 'node.attrs.[0].value');
    },
  },
  [WITH_TITLE]: {
    getQuery: type => gql`
      query DrilldownCellAttributeWithTitle($id: ID!, $names: [String]!) {
        node(id: $id) {
          attrs(names: $names) {
            ... on ${type} {
              value {
                sorTitle {
                  value
                }
              }
            }
          }
        }
      }
    `,
    update: result => {
      return get(result, 'node.attrs.[0].value.sorTitle.value');
    },
  },
  [WITH_TITLE_LIST]: {
    getQuery: type => gql`
      query DrilldownCellAttributeWithTitleList($id: ID!, $names: [String]!) {
        node(id: $id) {
          attrs(names: $names) {
            ... on ${type} {
              value {
                edges {
                  node {
                    ... on SorNode {
                      sorTitle {
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `,
    update: result => {
      return get(result, 'node.attrs.[0].value.edges', [])
        .map(edge => get(edge, 'node.sorTitle.value'))
        .join(', ');
    },
  },
};

export default Vue.extend({
  name: 'DashboardDrilldownCell',
  props: {
    nodeId: {
      type: String,
      default: () => null,
    },
    attribute: {
      type: Object,
      default: () => null,
    },
    defaultValue: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      value: null,
    };
  },
  apollo: {
    value: {
      query() {
        return this.query.getQuery(this.attribute.type);
      },
      variables() {
        return {
          id: this.nodeId,
          names: [this.attribute.name],
        };
      },
      update(result) {
        return this.query.update(result);
      },
      skip() {
        return !this.query || !this.nodeId || !this.attribute;
      },
    },
  },
  computed: {
    query() {
      if (!this.attribute) return;
      const { type } = this.attribute;
      const queryType = TYPE_MAP[type];
      return QUERY_MAP[queryType];
    },
    statusClass() {
      return this.attribute && this.attribute.name === 'status'
        ? `badge badge-${objectStatusColor(this.value) || 'light'}`
        : '';
    },
  },
});
